import { ErrorDefaultPage } from '@/feature/error/components/templates/ErrorDefaultPage';

type ErrorProps = {
  error: Error;
};

// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
export const Error: React.FC<ErrorProps> = () => {
  return <ErrorDefaultPage />;
};
